import React from "react";
import { format } from "date-fns";

import OrderSummaryItems from "../../../Common/Components/OrderSummaryItems";
import TotalPriceCard from "../../../Common/Components/SummaryTotalPriceCard";

const ReviewStep = ({
  items,
  open,
  setOpen,
  deliveryType,
  pickupDate,
  deliveryDate,
  paymentMethod,
  setPaymentMethod,
  total,
  walletBalance,
  walletLoading,
  address,
  note,
}) => {
  return (
    <>
      {/* Items */}
      {items.length > 0 && (
        <OrderSummaryItems items={items} open={open} setOpen={setOpen} />
      )}
      {/* Pricing */}
      <div className="card mb-3">
        <div className="card-body py-2">
          {deliveryType ? <TotalPriceCard deliveryType={deliveryType} /> : null}
        </div>
      </div>
      {/* Dates */}
      <div className="card mb-3">
        <div className="card-body">
          <h5 className="fw-bold">Scheduled Dates</h5>
          <div className="app-dates-container border border-gray rounded mt-4">
            <div className="col-12 col-md-5 px-4">
              <small
                style={{ position: "absolute", top: "-12px" }}
                className="bg-white px-2"
              >
                Pickup
              </small>
              <div className="d-flex align-items-center py-3 border-r border-gray">
                <i
                  className="fa-regular fa-calendar-plus me-3"
                  style={{ fontSize: "22px", color: "#666" }}
                ></i>
                {pickupDate?.date ? format(pickupDate.date, "eee, do MMM") : "Date"}
                {pickupDate?.date && pickupDate?.slot ? <br /> : "/"}
                {pickupDate?.slot
                  ? `${pickupDate?.slot?.start_time} - ${pickupDate?.slot?.end_time}`
                  : "Time"}
              </div>
            </div>
            <div className="col-1 d-none d-md-block border-start border-gray h-100 py-2 border-2">
              &nbsp;
            </div>
            <hr className="w-100 my-1 d-block d-md-none" />
            <div className="col-12 col-md-5 px-4">
              <small
                style={{ position: "absolute" }}
                className="bg-white px-2 app-dates-delivery-label"
              >
                Delivery
              </small>
              <div className="d-flex align-items-center py-3">
                <i
                  className="fa-regular fa-calendar-plus me-3"
                  style={{ fontSize: "22px", color: "#666" }}
                ></i>
                {deliveryDate?.date ? format(deliveryDate.date, "eee, do MMM") : "Date"}
                {deliveryDate?.date && deliveryDate?.slot ? <br /> : "/"}
                {deliveryDate?.slot
                  ? `${deliveryDate?.slot?.start_time} - ${deliveryDate?.slot?.end_time}`
                  : "Time"}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Payment Method */}
      <div className="card mb-3">
        <div className="card-body">
          <h5 className="fw-bold mb-3">Payment Method</h5>
          <div
            className="row cursor-pointer align-items-center py-3"
            onClick={() => setPaymentMethod("cash_on_delivery")}
          >
            <div className="col-11 d-flex align-items-center justify-content-between h-100">
              <div className="d-flex align-items-center">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/cash-on-delivery.png"}
                  style={{ height: "48px", width: "48px", objectFit: "contain" }}
                  className={`${
                    paymentMethod === "cash_on_delivery" ? "selected-payment-method" : ""
                  }`}
                  alt=""
                />
                <h6 className="ms-2 mb-0">Cash On Delivery</h6>
              </div>
              {paymentMethod === "cash_on_delivery" ? (
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/circle-check-solid.svg"}
                  style={{ width: "22px" }}
                  alt=""
                />
              ) : null}
            </div>
          </div>
          <hr className="border-1 my-0" style={{ borderStyle: "doted" }} />
          <div
            className="row cursor-pointer align-items-center py-3"
            onClick={() => setPaymentMethod("card_on_delivery")}
          >
            <div className="col-11 d-flex align-items-center justify-content-between h-100">
              <div className="d-flex align-items-center">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/card-on-delivery.png"}
                  style={{ height: "48px", width: "48px", objectFit: "contain" }}
                  className={`${
                    paymentMethod === "card_on_delivery" ? "selected-payment-method" : ""
                  }`}
                  alt=""
                />
                <h6 className="ms-2 mb-0">Card on Delivery</h6>
              </div>
              {paymentMethod === "card_on_delivery" ? (
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/circle-check-solid.svg"}
                  style={{ width: "22px" }}
                  alt=""
                />
              ) : null}
            </div>
          </div>
          <hr className="border-1 my-0" style={{ borderStyle: "doted" }} />
          <div
            className={`row align-items-center py-3 ${
              total <= walletBalance ? "cursor-pointer" : ""
            }`}
            onClick={() => {
              if (total <= walletBalance) setPaymentMethod("wallet_on_delivery");
            }}
          >
            <div className="col-11 d-flex align-items-center justify-content-between h-100">
              <div className="d-flex align-items-center">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/card-on-delivery.png"}
                  style={{
                    filter:
                      total > walletBalance
                        ? "invert(74%) sepia(9%) saturate(13%) hue-rotate(346deg) brightness(91%) contrast(91%)"
                        : "",
                    height: "48px",
                    width: "48px",
                    objectFit: "contain",
                  }}
                  className={`${
                    paymentMethod === "wallet_on_delivery" ? "selected-payment-method" : ""
                  }`}
                  alt=""
                />
                <h6
                  className="ms-2 mb-0"
                  style={{ color: total > walletBalance ? "#AAA" : "" }}
                >
                  Pay via Wallet (Rs. {walletBalance.toLocaleString()})
                </h6>
              </div>
              {walletLoading ? (
                <span className="spinner-border spinner-border-sm text-primary"></span>
              ) : paymentMethod === "wallet_on_delivery" ? (
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/circle-check-solid.svg"}
                  style={{ width: "22px" }}
                  alt=""
                />
              ) : null}
            </div>
          </div>
          <hr className="border-1 my-0" style={{ borderStyle: "doted" }} />
          <div
            className="row cursor-pointer align-items-center py-3"
            onClick={() => setPaymentMethod("digital_payment")}
          >
            <div className="col-11 d-flex align-items-center justify-content-between h-100">
              <div className="d-flex align-items-center">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/digital-payment.png"}
                  style={{ height: "48px", width: "48px", objectFit: "contain" }}
                  className={`${
                    paymentMethod === "digital_payment" ? "selected-payment-method" : ""
                  }`}
                  alt=""
                />
                <div className="ms-2">
                  <h6 className="mb-0">Digital Payment</h6>
                  <small>Pay online now using credit or debit card</small>
                </div>
              </div>
              {paymentMethod === "digital_payment" ? (
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/circle-check-solid.svg"}
                  style={{ width: "22px" }}
                  alt=""
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
      {/* Addresses */}
      <div className="card mb-3">
        <div className="card-body">
          <h5 className="fw-bold mb-3">Address</h5>
          <div className="row cursor-pointer">
            <div className="col-1 text-end pe-0">
              <i className="fa-solid fa-circle-dot" style={{ color: "#32b6e9" }}></i>
            </div>
            <div className="col-11">
              <h6 className="mb-1">Pickup Address</h6>
              <p className="m-0">
                {address?.pickup
                  ? `${address?.pickup?.address1}, ${address?.pickup?.address2}, ${address?.pickup?.area?.[0]?.name}, ${address?.pickup?.phase?.[0]?.name}`
                  : "Select address"}
              </p>
            </div>
          </div>
          <div style={{ margin: "20px 0px" }}></div>
          <div className="row cursor-pointer">
            <div className="col-1 text-end pe-0">
              <i className="fa-solid fa-location-dot text-primary" style={{ fontSize: "20px" }}></i>
            </div>
            <div className="col-11">
              <h6 className="mb-1">Delivery Address</h6>
              <p className="m-0">
                {address?.delivery
                  ? `${address?.delivery?.address1}, ${address?.delivery?.address2}, ${address?.delivery?.area?.[0]?.name}, ${address?.delivery?.phase?.[0]?.name}`
                  : "Select address"}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Note */}
      {note && note !== "" ? (
        <div className="card mb-3">
          <div className="card-body">
            <h5 className="fw-bold mb-3">Order Note / Instructions.</h5>
            <ul>
              {(note || []).map((n, i) => <li key={n.id ?? i}>{n.note}</li>)}
            </ul>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default ReviewStep;
